<template>

    <div class="wrapper-main page-container">

        <header-band
                :title="$t('login_email_web_header')"
                :blueCleanfox="true"
                :back="true"
                @eventBack="back"
                :border="false"
        ></header-band>

        <login-provider-tuto-web v-if="step === 1"
                   :provider="provider"
                   :logoSrc="logoProvider"
                   @back="back"
                   @next="goStep(2)"></login-provider-tuto-web>

        <login v-if="step === 2"
                :provider="provider"
                :logoSrc="logoProvider"
                :appPass="true"
                @goAppPass="goStep(1)"></login>

    </div>

</template>

<script>

    import Vuex from 'vuex'

    import Storage from '@/helpers/storage'

    import HeaderBand from '@/components/headers/HeaderBand'
    import Login from '@/components/loginFlow/Login'
    import LoginProviderTutoWeb from '@/components/loginFlow/LoginProviderTutoWeb'
    import Markdown from '@/components/Markdown'
    import PageLoader from "@/components/PageLoader"

    import Tag from '@/modules/tag'
    import UserFlow from '@/modules/userFlow'

    export default {

        name: 'login-provider',

        components: { HeaderBand, Login, LoginProviderTutoWeb, Markdown, PageLoader},

        watch:{
            $route (to){
                this.provider = to.params.provider
                this.step = 1
            }
        },

        computed: {

            ...Vuex.mapGetters(['loginEmail']),

            logoProvider() {
              let link = ''

              switch (this.provider) {
                case 'yahoo':
                  link = '/img/providers/yahoo.svg'
                  break
                case 'icloud':
                  link = '/img/providers/icloud.svg'
                  break
                case 'google':
                  link = '/img/providers/google.png'
                  break
                case 'windowslive':
                case 'outlook':
                  link = '/img/providers/microsoft.svg'
                  break
              }
              return link
            }

        },

        data() {
            return {
                provider: '',
                step: 0,
                email: ''
            }
        },

        created() {

            this.provider = this.$route.params.provider

            UserFlow.setPage(this, `login_${ this.provider }`)

            window.addEventListener('scroll', this.handleScroll)
        },

        mounted() {

            //for pageView
            this.goStep(1)

        },

        methods: {

          goStep (step) {

            this.step = step
            this.pageTop()

            switch (step) {
              case 1:
                UserFlow.setPage(this, `login_${ this.provider }_tuto_web`, this.provider)
                break
              case 2:
                Tag.pageViewAmplitude(this, `login_${this.provider}`)
                break
            }
          },

          pageTop () {
            window.scrollTo(0, 0)
          },

          back () {

            if (this.step === 1) {

              if (Storage.getItem('token')) {

                this.$router.push({ path: '/add-inbox' })

              } else {

                this.$router.push({ path: '/' })

              }

            } else {

              this.goStep(1)

            }

          },

          testPassword () {

            this.isErrorPassword = !this.$refs.inputPassword.value.length
            return !this.isErrorPassword
          }
        }
    }
</script>

<style scoped lang="scss">

    .page-container {
        min-height: inherit;
        height: auto;
        align-items: center;
        background-color: $white;
        display: flex;
        flex-direction: column;
        @media screen and (min-width: $above-tablet-length) {
            background-image: url(/img/background/cards-desktop.svg);
            background-repeat: no-repeat;
            background-position: bottom;
            background-size: cover;
            background-blend-mode: luminosity;
            background-color: $timberwolf;
        }
    }

</style>
